import {Component} from '@angular/core';

@Component({
    selector: 'qa-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent {

}
